<template>
  <div class="message_board">
    <!-- <div class="message_board_icon" @click.stop="show">
      <Badge :count="$store.state.badge.ask">
        <Icon type="ios-chatbubbles"></Icon>
        疑问
      </Badge>
    </div> -->
    <transition name="bounce"
        enter-active-class="animated fadeInUp"
        leave-active-class="animated fadeOutDown">
      <div class="message_board_modal" v-show="visible">
        <div class="message_board_modal_hd" style="position:absolute;width:100%;z-index:10;" v-if="messageTab=='list'">
          <Button type="text" icon="md-close" style="float:right;padding:0 5px" @click="hide"></Button>
          <h5>疑问列表&nbsp;&nbsp;<Button icon="md-refresh" size="small" @click="fetchData" style="height:20px;padding:0 5px">刷新</Button></h5>
        </div>
        <div class="message_board_modal_hd" style="position:absolute;width:100%;z-index:10;" v-else>
          <Button type="text" icon="md-close" style="float:right;padding:0 5px" @click="hide"></Button>
          <h5>疑问详情&nbsp;&nbsp;<Button icon="ios-arrow-back" size="small" @click="back" style="height:20px;padding:0 5px">返回列表</Button></h5>
        </div>
        <transition name="bounce"
        enter-active-class="animated fadeInLeft"
        leave-active-class="animated fadeOutLeft">
          <div class="message_board_content" v-if="messageTab=='list'">
            <div class="message_board_modal_hd" style="height:42px;"></div>
            <div class="message_board_modal_bd message-list" v-if="messageTab=='list'">
              <div class="message-item left" v-for="(item,ind) in list" :key="ind">
                <div class="avatar">
                  <Avatar icon="person" size="large" :src="item.headimgurl"></Avatar>
                  <span class="name">{{item.username}}</span>
                </div>
                <div class="message" @click="toReply(item)">
                  <div><span style="color:#999">[{{item.type}}]</span> {{item.message}}</div>
                  <div class="buttons">
                    <Button type="info" size="small" v-if="item.status == 0 && item.count == 0">待回复</Button>
                    <Button type="default" disabled size="small" v-if="item.status == 1">已完成</Button>
                  </div>
                  <div class="time">
                    <Icon type="android-time"></Icon>{{item.created_at}}&nbsp;&nbsp;
                    <Icon type="reply"></Icon>{{item.count}}&nbsp;&nbsp;
                    <Icon type="eye"></Icon>{{item.view||0}}
                  </div>
                </div>
              </div>
              <loading :visible="loadState" :text="loadText" :icon="loadIcon"></loading>
              <div class="pager" v-if="page.page<page.total" @click="page.page = page.page+1;fetchData()">加载更多</div>
            </div>
            <div class="message_board_modal_fd" style="text-align:left;padding:8px;">
              <div class="reply-box" style="display:inline-block">
                <Select style="width:90px" v-model="messageForm.type" ref="messageType" size="small" placement="top">
                  <Option value="技术问题" label="技术问题"></Option>
                  <Option value="薪资问题" label="薪资问题"></Option>
                  <Option value="其他" label="其他"></Option>
                </Select>
                <Input size="small" v-model="messageForm.message" style="width:420px;" placeholder="请输入内容"></Input>
                <Tooltip placement="left" content="您有一个进行中的问题还未解决?" v-if="isIng==1">
                  <Button size="small" icon="edit" type="info" :disabled="true" @click="submit">提问</Button>
                </Tooltip>
                <Button size="small" icon="edit" v-else type="info" @click="submit">提问</Button>
              </div>
            </div>
          </div>
        </transition>
        <transition name="bounce"
        enter-active-class="animated fadeInLeft"
        leave-active-class="animated fadeOutLeft">
          <div class="message_board_content" v-if="messageTab=='detail'">
            <div class="message_board_modal_hd" style="height:42px;"></div>
            <div class="message_board_modal_bd" ref="messageReply">
              <!-- <Affix :offset-top="50"> -->
                <div class="message-item reply-title" ref="replyTitle" style="overflow:visible">
                  <div style="float:right">
                    <Poptip
                      confirm
                      width="200"
                      title="确认已经完成了吗？"
                      placement="bottom-end"
                      v-if="replyForm.status==0 && $store.state.userInfo.id == replyForm.user_id"
                      @on-ok="confirmEnd(replyForm.reply_id, 1)">
                      <Button type="error" icon="checkmark-circled" size="small">确认完成</Button>
                    </Poptip>
                    <Tag color="yellow" v-if="replyForm.status==1">已完成</Tag>
                  </div>
                  <div class="avatar">
                    <Avatar icon="person" size="large" :src="curReply.headimgurl"></Avatar>
                  </div>
                  <div class="message">
                    <span class="name">{{curReply.username}}</span>
                    <div>{{curReply.message}}</div>
                    <div class="time"><Icon type="android-time"></Icon> {{curReply.created_at}}</div>
                  </div>
                </div>
              <!-- </Affix> -->
              <!-- <div class="pager" v-if="replyPage.page - 1 >= 0" @click="fetchReply(replyForm.reply_id)">加载更多</div> -->
              <Scroll :on-reach-top="handleReachBottom" :disabled="true" height="420" :style="scrollStyle" :loading-text="scrollLoadText">
                <template v-for="(item,ind) in reply">
                  <div class="message-item" :key="ind" :class="{'left':item.user_id == curReply.user_id,'right':item.user_id != curReply.user_id}">
                    <div class="avatar">
                      <Avatar icon="person" size="large" :src="item.headimgurl"></Avatar>
                      <span class="name">{{item.username}}</span>
                    </div>
                    <div class="message" :key="'mesage_'+ind" >
                      <div>{{item.message}}</div>
                      <div class="time"><Icon type="android-time"></Icon> {{item.created_at}}</div>
                    </div>
                  </div>
                </template>
              </Scroll>
            <loading :visible="loadState" :text="loadText" :icon="loadIcon"></loading>
              <div style="position:absolute;bottom:0;left:0;padding:10px;color:#999;z-index:-1">
                当前在线：
                <span v-for="(item,ind) in online['room_'+ curReply.id]" :key="ind" style="margin-right:10px;">{{item}}</span>
              </div>
            </div>
            <div class="message_board_modal_fd" style="text-align:left;padding:8px;">
              <div class="reply-box" style="display:inline-block">
                <Input size="small" style="width:520px;" v-model="replyForm.message" placeholder="请输入内容"></Input>
                <Button size="small" icon="reply" type="info" :disabled="replyForm.status==1" @click="submitReply">回复</Button>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </transition>
  </div>
</template>

<script>
  import {post, fetch, put} from '../fetch/api'
  // import validate from '../util/validateForm'
  let loadText = ['加载中', '暂无疑问', '加载错误请重试！']

  if (!window.requestAnimationFrame) {
    // const requestAnimationFrame = function (fn) {
    //   setTimeout(fn, 17)
    // }
  }

  // var scrollToBottom = function (A, B, rate, callback) {
  //   if (A === B || typeof A !== 'number') {
  //     return
  //   }
  //   B = B || 0
  //   rate = rate || 2

  //   var step = function () {
  //     A = A + (B - A) / rate

  //     if (A < 1) {
  //       callback(B, true)
  //       return
  //     }
  //     callback(A, false)
  //     requestAnimationFrame(step)
  //   }
  //   step()
  // }

  export default {
    name: 'MessageBoard',
    components: {
      Loading: resolve => { require(['../components/LoadingComponent'], resolve) }
    },
    props: {
      visible: {
        default: false
      }
    },
    data () {
      return {
        scrollStyle: {},
        online: [],
        list: [],
        reply: [],
        curReply: {},
        messageForm: {
          type: '',
          message: ''
        },
        scrollLoadText: '加载中...',
        replyForm: {
          user_id: 0,
          reply_id: 0,
          type: '',
          message: '',
          status: 0
        },
        messageTab: 'list',
        formName: '',
        loadState: false,
        loadIcon: 'ios-information', // refresh
        loadText: loadText[0],
        loadedPage: [],
        isIng: 0, // 是否有进行中的问题
        page: {
          total: 0,
          page: 1
        },
        replyPage: {
          total: 0,
          page: 1
        }
      }
    },
    watch: {
      visible (val) {
        if (val) this.fetchData()
      }
    },
    mounted () {
    },
    // sockets: {
    //   userlist (list) {
    //     let json = JSON.parse(list)
    //     if (this.online[json.name]) this.online[json.name] = []
    //     this.$set(this.online, json.name, json.users)
    //   },
    //   rmsg (msg) {
    //     this.$Notice.info({
    //       title: '提示',
    //       duration: 5,
    //       desc: msg
    //     })
    //     if (this.replyForm.reply_id > 0) this.fetchReply(this.replyForm.reply_id, 'push')
    //   }
    // },
    methods: {
      fetchData () {
        this.loadState = true
        this.loadIcon = 'refresh'
        this.loadText = '正在加载...'
        // this.list = []
        fetch('message/0', {params: {page: this.page.page}}).then(res => {
          if (res.status === 'ok') {
            this.isIng = res.ing
            this.loadState = false
            this.page.total = res.result.last_page
            if (res.result.data.length === 0) {
              this.loadState = true
              this.loadIcon = 'alert-circled'
              this.loadText = '暂无数据'
            } else {
              this.listPush(res.result.data, 'list', 'push')
            }
          }
        })
      },
      fetchReply (id, insert) {
        this.loadState = true
        this.loadIcon = 'refresh'
        let page = insert === 'push' ? 1 : this.replyPage.page

        fetch(`message/reply/${id}`, {params: {page: page}}).then(res => {
          if (res.status === 'ok') {
            let data = res.result.data
            data = data.sort(this.compare('id'))
            this.loadState = false
            this.replyPage.total = res.result.last_page
            this.listPush(data, 'reply', insert)
            if (insert === 'push') {
              setTimeout(() => {
                this.scrollToBottom(3.5)
              }, 400)
            }
          }
        })
      },
      compare (property) {
        return function (a, b) {
          var value1 = a[property]
          var value2 = b[property]
          return value1 - value2
        }
      },
      listPush (data, key = 'list', insert = 'push') {
        if (data.length > 0) {
          for (let k in data) {
            if (!this.isInList(data[k], key)) {
              if (insert === 'push') this[key].push(data[k])
              if (insert === 'unshift') this[key].unshift(data[k])
            }
          }
        }
      },
      isInList (item, key = 'list') {
        for (let k in this[key]) {
          if (this[key][k].id === item.id) return true
        }
        return false
      },
      pagerChange (val) {
        this.page.page = val
        this.fetchData()
      },
      submit () {
        if (!this.messageForm.type) {
          this.$Message.error('请选择类型！')
          return false
        }
        if (!this.messageForm.message) {
          this.$Message.error('请输入疑问内容')
          return false
        }
        post('message', this.messageForm).then(() => {
          this.isIng = 1
          this.fetchData()
        })
      },
      submitReply () {
        if (!this.replyForm.message) {
          this.$Message.error('请输入内容')
          return false
        }
        post('message', this.replyForm).then(() => {
          this.fetchReply(this.replyForm.reply_id, 'push')
        })
      },
      toReply (item) {
        this.replyPage.page = 1
        this.messageTab = 'detail'
        this.reply = []
        this.replyForm.user_id = item.user_id
        this.replyForm.reply_id = item.id
        this.replyForm.status = item.status
        this.curReply = item
        setTimeout(() => {
          document.querySelector('.ivu-scroll-wrapper').style.paddingTop = this.$refs.replyTitle.offsetHeight + 'px'
        }, 1000)
        this.addView(item.id)
        this.fetchReply(item.id, 'push')
        // 创建、加入房间
        this.$socket.emit('join', this.$store.state.userInfo.username, 'room_' + item.id, this.$store.state.userInfo.id)
      },
      addView (id) {
        put(`message/${id}/view`)
      },
      handleReachBottom () {
        if (this.replyPage.page + 1 >= this.replyPage.total) {
          this.scrollLoadText = '已经没有了！'
          return new Promise(resolve => { resolve() })
        }
        this.scrollLoadText = '加载中...'
        return new Promise(resolve => {
          setTimeout(() => {
            this.replyPage.page = this.replyPage.page + 1
            this.fetchReply(this.replyForm.reply_id, 'unshift')
            resolve()
          }, 1500)
        })
      },
      scrollToBottom (rate) {
        // 滚动到最下面
        this.replyForm.message = ''
        let ele = document.querySelector('.ivu-scroll-container')
        let scrollTop = ele.scrollTop
        let scrollHeight = ele.scrollHeight

        let top = function () {
          scrollTop = scrollTop + (scrollHeight - scrollTop) / (rate || 2)

          // 临界判断，终止动画
          if (scrollTop > scrollHeight - 1) {
            ele.scrollTop = scrollHeight
            return
          }
          ele.scrollTop = scrollTop
          // 动画gogogo!
          requestAnimationFrame(top)
        }
        top()
      },
      confirmEnd (id, status) {
        put(`message/${id}/status/${status}`).then(res => {
          if (res.status === 'ok') {
            this.$set(this.replyForm, 'status', status)
            this.$store.dispatch('setBadge', {key: 'ask', 'value': this.$store.state.badge.ask - 1})
            this.$Message.info(res.msg)
          } else {
            this.$Message.error(res.msg)
          }
        })
      },
      back () {
        this.list = []
        this.page.page = 1
        this.fetchData()
        this.messageTab = 'list'
        this.replyForm.reply_id = 0
        this.$socket.emit('leave', 'user_' + this.$store.state.userInfo.id, 'room_' + this.replyForm.reply_id)
      },
      show () {
        this.$emit('update:visible', true)
      },
      hide () {
        this.$emit('update:visible', false)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .message_board_content{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: 1;
  }
  .message_board_icon{
    position: fixed;
    top: 50%;
    right: 0;
    z-index: 2000;
    width: 50px;
    height: 65px;
    text-align: center;
    padding: 10px 0;
    font-size: 12px;
    border-radius: 10px 0 0 10px;
    background: #fff;
    border: 1px solid #ddd;
    box-shadow: 0 0 10px rgba(0, 0, 0, .4);
    cursor: pointer;
  }
  .message_board_icon:hover{
    color: #2d8cf0;
  }
  .message_board_icon .ivu-icon{
    display: block;
    font-size: 32px;
  }
  .message_board_modal{
    width: 600px;
    height: 600px;
    position: fixed;
    overflow-y: hidden;
    bottom: 5px;
    right: 5px;
    z-index: 2001;
    border: 1px solid #ddd;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 0 10px rgba(0, 0, 0, .4);
  }
  .message_board_modal_hd{
    padding: 10px;
    background: #f1f1f1;
    border-bottom: 1px solid #ddd
  }
  .message_board_modal_bd{
    position: relative;
    box-shadow: inset 0 0 10px rgba(0, 0, 0, .3);
    height: 510px;
    margin: 2px;
    overflow-y: scroll;
    padding: 10px 0 0;
  }
  .message_board_modal_fd{position: absolute;width:100%;bottom:0;left:0;}
  .message-item{
    padding: 10px 10px 20px;
    overflow: hidden;
    position: relative;
    min-height: 50px;
  }
  .message-item .avatar{
    position: absolute;
    top: 10px;
    left: 10px;
    text-align: center;
  }
  .message-item .avatar .name{width:40px;display: block;color:#999;font-size:12px;white-space: nowrap;overflow:hidden;}
  .message-item .ivu-avatar{
    background: #add4f7;
  }
  .message-item .message{
    min-width: 200px;
    display: inline-block;
    min-height: 50px;
    border: 1px solid #add4f7;
    margin: 0 50px;
    padding: 6px;
    border-radius: 4px;
    position: relative;
    background: #dfefff
  }
  .reply-title{
    background: #fbe5c3;
    border-bottom: 1px solid #ecaf51;
    border-radius: 4px;
    margin: 0 10px 10px;
    position: absolute;
    top: 10px;
    left: 0;
    right: 0;
    z-index: 10
  }
  .reply-title.message-item .message{
    min-width: auto;
    min-height: auto;
    background: transparent;
    padding: 0;
    border: none;
    display: block;
  }
  .reply-title.message-item .message .time{display: block;clear:both;}
  .reply-title.message-item .message:after{display: none}
  .message-item .time{
    color: #999;
    position: absolute;
    bottom: -20px;
  }
  .message-item .badge{width:16px;height:12px;border:1px solid #ccc;border-radius: 10px;line-height:12px;display: inline-block;}
  .message-item .time .ivu-icon{margin-right:5px;}
  /*.message-item.right .time .ivu-icon{float:right;}*/
  .message-item .message:after{
    content: '';
    width: 0;
    height: 0;
    display: block;
    border: 6px solid #add4f7;
    position: absolute;
    left: -12px;
    top: 15px;
    border-color: transparent #add4f7 transparent transparent
  }
  .message-item.right{text-align: right;}
  .message-item.right .time{text-align: left}
  .message-item.right .message{
    border: 1px solid #c8d69c;
    background: #ebf7c6;
    text-align: left;
  }
  .message-item.right .message:after{
    left: auto;
    right: -12px;
    border-color: transparent transparent transparent #c8d69c
  }
  .message-item.right .avatar{
    left: auto;
    right: 10px;
  }
  .message-item.right .ivu-avatar{
    background: #c8d69c;
  }

  .message-item .buttons{position: absolute;top:50%;margin-top:-18px;right:6px;padding:5px;}
  .message-list .message{
    display: block;
  }
  @media (max-width: 640px) {
    .message_board_modal{
      width: 100%;
      height: 100%;
      right: 0;
      top: 0;
      bottom: 0;
    }
    .message_board_modal_bd{
      left: 2px;
      right: 2px;
      top: 44px;
      bottom: 40px;
      height: auto;
      position: absolute;
      margin: 0;
      overflow-y: scroll;
      padding: 10px 0 0;
    }
    .message_board_modal_fd .ivu-input-wrapper{
      width: 160px !important;
    }
  }
  /*
  @keyframes bounce-in {
    0% {
      transform: scale(0);
    }
    50% {
      transform: scale(1.5);
    }
    100% {
      transform: scale(1);
    }
  }*/
</style>
<style>
  @media (max-width: 640px) {
    .message_board_modal_bd .ivu-scroll-wrapper,
    .message_board_modal_bd .ivu-scroll-container{
      height: 100% !important;
    }
  }
</style>
